module.exports = __webpack_public_path__ + "img/move-black.2d038930.svg";